<template>
  <div class="p-16 w-full flex flex-row justify-between bg-white">
    <div class="w-full pr-16">
      <div class="w-full h-32 mb-8 animate-pulse bg-grey-divider-subdued"></div>
      <div class="w-full h-16 mb-8 animate-pulse bg-grey-divider-subdued"></div>
      <div class="w-full h-16 mb-8 animate-pulse bg-grey-divider-subdued"></div>
      <div class="w-full h-40 mb-8 animate-pulse bg-grey-divider-subdued"></div>
    </div>
    <div class="w-full max-w-96 rounded-full animate-pulse h-96 bg-grey-divider-subdued"></div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'SitterCardLoadingSkeleton',
});
</script>
